import actions from '@gov.wa.lni/application.isolated-workers-complaint/source/components/lni-isolated-workers-complaint-form/actions';

export default () => ({
    state: {
        displayPageError: false,
        displayFormError: false,
        retaliationSelected: false,
        trackedErrors: [],
    },
    getters: {
        retaliationSelected(state) {
            return state.retaliationSelected;
        },
    },
    actions: {
        ...actions,
    },
    mutations: {
        SET_VALUE(state, payload) {
            state[payload.key] = payload.value;
        },
        ADD_TRACKED_ERRORS(state, payload) {
            for (let item of payload) {
                if (state.trackedErrors.indexOf(item) === -1) {
                    state.trackedErrors.push(item);
                }
            }
        },
        REMOVE_TRACKED_ERRORS(state, payload) {
            for (let item of payload) {
                let index = state.trackedErrors.indexOf(item);
                if (index > -1) {
                    state.trackedErrors.splice(index, 1);
                }
            }
        },
    },
});